import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminEchomapUhd273sv = () => {
  // Get the product data directly from screensData
  const productId = "echomap-73sv-uhd2";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminEchomapUhd273sv - Direct Import - Product Data:', productData);
  console.log('GarminEchomapUhd273sv - Direct Import - Image URL:', productData?.image);
  
  // Use the direct image URL provided
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-echomap-uhd2-73sv.jpg";
  
  return (
    <SimpleProductPage 
      specificProductId="echomap-73sv-uhd2"
      productName="Garmin ECHOMAP UHD2 73sv"
      productImage={imageUrl}
    />
  );
};

export default GarminEchomapUhd273sv; 